export const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const PHONE_REGEX = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
export const ONLY_ALPHABETIC_CHARACTERS = /^[a-z]+$/i;
export const ZIP_CODE = /^\d{5}(-\d{4})?$/;
export const DATE = /^\d{4}-\d{2}-\d{2}$/;
export const BIRTH_DATE = /^\d{2}-\d{2}-\d{4}$/;
export const DATE_TIME_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
export const DIGIT_REGEX = /^\d+$/;

const Regex = {
  EMAIL_REGEX,
  PHONE_REGEX,
  ONLY_ALPHABETIC_CHARACTERS,
  ZIP_CODE,
  DATE,
  BIRTH_DATE,
  DATE_TIME_REGEX,
  DIGIT_REGEX,
};
export default Regex;
